<template>
    <v-app id="app">
        <div v-show="!isLoading">
            <vDrawer v-if="$route.name !== 'login'" />
            <vView />
        </div>
        <div v-show="isLoading || isOpacityLoading" class="loading-modal">
            <v-overlay>
                <v-progress-circular
                    :size="60"
                    :width="6"
                    indeterminate
                />
            </v-overlay>
        </div>
        <div v-show="authError" class="loading-modal">
            <v-overlay>
                <div class="d-flex flex-column align-items-center">
                    <h2 class="mb-4">セッションが切れました。</h2>
                    <v-btn @click="logout();" color="error" x-large>ログイン画面へ戻る</v-btn>
                </div>
            </v-overlay>
        </div>
    </v-app>
</template>

<script>
import { mapState } from 'vuex';
import vDrawer from './components/core/Drawer';
import vView from './components/core/View';
import { GET_LOGIN_ADMIN } from './constants/login';
import { ADMIN_LOGOUT } from './constants/side_menu';

export default {
    name: 'App',
    components: {
        vDrawer,
        vView
    },
    data () {
        return {
            // API実行間隔(マイクロ秒)
            // ※キリがいい時間だとセッション切れの直前のタイミングと重なる可能性が高くなるので微妙にずらす
            intervalTime: 62000,
            authError: false
        };
    },
    computed: {
        ...mapState('loading', ['isLoading', 'isOpacityLoading'])
    },
    methods: {
        async checkAuth () {
            if (!this.authError && this.$route.path !== '/login') {
                await this.$apollo
                    .query({ query: GET_LOGIN_ADMIN, fetchPolicy: 'no-cache' })
                    .then(res => {
                        this.authError = false;
                    })
                    .catch(error => {
                        this.authError = true;
                        this.error = error;
                    });
            }
        },
        /** --------------------------------------------
         * ログアウト処理
         * -------------------------------------------- */
        logout () {
            this.$apollo.mutate({
                mutation: ADMIN_LOGOUT,
                variables: {}
            }).then(res => {
                localStorage.setItem('apollo-token', '');
                this.$router.push('/login');
                this.authError = false;
            });
        }
    },
    mounted: function () {
        setInterval(this.checkAuth, this.intervalTime);
    }
};
</script>

<style>
.loading-modal {
    z-index: 999;
}
</style>
